"use client";
import React, { useState } from "react";
import { QuickChallenges } from "./QuickChallenges";
import ChallengePathNavigator from "./ChallengePathNavigator";

export const ChallengesContent = () => {
  const [activeTab, setActiveTab] = useState("quick");

  const tabs = [
    { id: "quick", label: "Quick Challenges", component: <QuickChallenges /> },
    {
      id: "path",
      label: "Challenge Path",
      component: <ChallengePathNavigator />,
    },
  ];

  return (
    <div className="w-full">
      <div className="flex gap-6 mb-8 border-b border-[#2A2A2A] px-5 md:px-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`pb-3 text-sm font-medium transition-colors cursor-pointer border-b-2 -mb-px ${
              activeTab === tab.id
                ? "text-white border-white"
                : "text-[#808080] border-transparent hover:text-white"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div>{tabs.find((tab) => tab.id === activeTab)?.component}</div>
    </div>
  );
};
